/* Block - Statistics.
 *
 * Imports the block css.
 * Contains block-specific functionality.
 *
 * @file single
 *
 */
/* eslint-disable-next-line */
import styles from "./block-statistics.scss";
